import { flexGapPolyfill } from 'shared/components/Base/FlexBox'
import { OutlinedIcon } from 'shared/components/Icons/OutlinedIcon'
import styled, { css } from 'styled-components'

import { muiTheme } from '../../theme'

export const MessageContainer = styled.div<{
  $mt?: number
  $background: string
  $alignCenter?: boolean
  $isSlim?: boolean
}>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 20px 22px;
  border-radius: 6px;
  background: ${({ $background }) => $background};
  ${({ $alignCenter }) => $alignCenter && `align-items: center;`};
  ${flexGapPolyfill('20px')};
  ${({ $isSlim }) =>
    $isSlim &&
    `align-items: center; padding: 10px 15px; ${flexGapPolyfill('10px')}; > div { padding-top: 4px; } `};

  ${(p) =>
    p.$mt &&
    css`
      margin-top: ${muiTheme.spacing() * p.$mt}px;
    `};
`

export const MessageIcon = styled(OutlinedIcon)<{ $color: string }>`
  width: 30px;
  height: 30px;
  padding: 3px;
  color: ${({ $color }) => $color};
  background: white;
  margin: 0;
`
